import React from "react";
import {useBehaviour} from "./useBehaviour";
import {View} from "./view";

export const MainPage = () => {
  return (
    <View {...useBehaviour({ sources: 'sources' })} />
  );
};